import * as validations from '../../../../validations/validations';

import { FormInputModel, HandleValueModel } from '../../../../models';

import { FormInput } from '../../..';
import React from 'react';
import { State } from 'stores/shared/NewStatefulFunction';
import objectHelper from '../../../../utils/ObjectHelper';
import { observer } from 'mobx-react';
import { useLocalization } from 'localization/LocalizationProvider';
import { useStore } from 'stores/MobXTypedStoreHook';

const IntakeIntegrationField = () => {
  const translate = useLocalization();
  const { artificialIntelligenceModel } = useStore(x => x.settingsStore);

  return <FormInput {...{
    translate,
    model: new FormInputModel({
      readonly: artificialIntelligenceModel.updateDefaultAIConstants.state === State.Processing,
      validationSchema: validations.getBasicNumberSchema(),
      placeholder: translate(x => x.forms.airdome.artificialIntelligence.intakeIntegration),
      handleValueModel: new HandleValueModel({
        setValue: artificialIntelligenceModel.inputTemperatureIntegrationRegulation.setValue,
        inputType: 'number'
      }),
      label: translate(x => x.forms.airdome.artificialIntelligence.intakeIntegration),
      inputId: 'AIIntakeIntegration',
      value: objectHelper.executeIfNumber(
        artificialIntelligenceModel.inputTemperatureIntegrationRegulation.Value,
        x => x.toString())
        || ''
    })
  }} />
};

export default observer(IntakeIntegrationField);
